export default function cleanCrumb(crumb) {
  const { fullPath, meta, name, params, path, query } = crumb;
  return { fullPath, meta, name, params, path, query };
}